import { gql } from 'graphql.macro';

export const AddUser = gql`
    mutation addUser($employeeId: Int!, $profileIds: [Short!]) {
        addUser: createUser(employeeId: $employeeId, profileIds: $profileIds)
    }
`;
